import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Web app's Firebase configuration
// User should replace these values or use environment variables
const firebaseConfig = {
    apiKey: "AIzaSyBLCOJwUom4ZSAsFAzkX7P_lYuzmxWoBZk",
    authDomain: "fibre-97391.firebaseapp.com",
    projectId: "fibre-97391",
    storageBucket: "fibre-97391.firebasestorage.app",
    messagingSenderId: "394650352234",
    appId: "1:394650352234:web:5378d3d05d77e68fed6813"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;
